@if (uiController === UIControlTyp.MultiSelectList) {
  <kendo-multiselect
    textField="name"
    valueField="id"
    [valuePrimitive]="true"
    [data]="PublicFundingList"
    [filterable]="true"
    (filterChange)="filterPublicFundingList($event)"
    [value]="SelectedPublicFundingIds"
    placeholder="Bisher keine öffentliche Förderung ausgewählt. Bitte wählen Sie einen oder mehrere Werte aus."
    (valueChange)="valueChanged($event)">
  </kendo-multiselect>
}
@if (uiController === UIControlTyp.DropDownList) {
  <kendo-dropdownlist
    class="fdb-kendo-dropdown"
    textField="name"
    valueField="id"
    [data]="PublicFundingList"
    [(ngModel)]="PublicFunding"
    (valueChange)="valueChanged($event)">
  </kendo-dropdownlist>
}
@if (uiController === UIControlTyp.GridSingleValueField) {
  {{ getName() }}
}

